const featuresData = [
  {
    id: 1,
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '7x24小时全天候监测各大平台，热点事件发生后最快5分钟内上架，确保您不会错过任何一条劲爆黑料。',
  },
  {
    id: 2,
    icon: 'ri-shield-check-line',
    title: '多重验证',
    desc: '每条爆料均经过编辑团队交叉核实，标注信息来源与可信度等级，让您吃得明明白白的瓜。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '全端适配',
    desc: '支持电脑、平板、手机全平台访问，51吃瓜黑料入口一二三随时随地打开即看，吃瓜不受设备限制。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            本站优势
          </h2>
          <p className="mt-2 text-sm text-foreground-500">为什么千万吃瓜群众选择51吃瓜黑料</p>
        </div>

        <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="text-center p-6 bg-background-100 border border-background-200/60 rounded-lg"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-100 text-primary-500">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-heading font-bold text-foreground-950 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}